import type { Snapshot } from '@ember-data/legacy-compat/-private';
import ApplicationSerializer from 'lumen/serializers/application';

export default class PropertyTagsPropertyTagsSerializer extends ApplicationSerializer {
  attrs = {
    subscription: 'subscription_id',
    regionalDos: 'regional_dos_id',
    regionalVp: 'regional_vp_id',
    dorm: 'dorm_id',
  };

  primaryKey = 'subscription';

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  modelNameFromPayloadKey(key: string) {
    if (key === 'subscriptions') {
      return 'property-tags/subscription';
    }

    if (key === 'users') {
      return 'property-tags/user';
    }

    return 'property-tags';
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  serialize(snapshot: Snapshot, options: object) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    const payload = super.serialize(snapshot, options) as Record<
      string,
      unknown
    >;

    if ('subscription' in payload) {
      delete payload['subscription'];
    }

    if ('is_read_only' in payload) {
      delete payload['is_read_only'];
    }

    // Backend expects the ids to be integers
    Object.keys(payload)
      .filter((key) => key.includes('_id'))
      .forEach((key: keyof typeof payload) => {
        if (typeof payload[key] === 'string') {
          payload[key] = parseInt(payload[key], 10);
        }
      });

    return payload;
  }
}
